module.exports = __webpack_public_path__ + "static/media/stickermule_logo.476f4b47.png";